import React from "react";

import styles from "./backdrop.module.scss";

export default function Backdrop(props) {
  return (
    props.show && <div className={styles.backdrop} onClick={props.click} style={{zIndex: props.zIndex}}/>
  )
}
